module.exports = __webpack_public_path__ + "fonts/InterMedium.1aa99aa2.TTF";